/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Models_DescriptionInputs */

const en_seo_models_description = /** @type {(inputs: Seo_Models_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare LLM, image, video, and audio AI models for developers with pricing and capability data.`)
};

const zh_seo_models_description = /** @type {(inputs: Seo_Models_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比面向开发者的 LLM、图像、视频、音频 AI 模型，含定价与能力数据。`)
};

/**
* | output |
* | --- |
* | "Compare LLM, image, video, and audio AI models for developers with pricing and capability data." |
*
* @param {Seo_Models_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_models_description = /** @type {((inputs?: Seo_Models_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Models_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_models_description(inputs)
	return zh_seo_models_description(inputs)
});
export { seo_models_description as "seo.models.description" }